import { fabric } from 'fabric';

export const initCanvasFabric = (canvasId) => new fabric.Canvas(canvasId, { selection: false });

export const addMouseEventListenersForDrawing = (canvasFabric) => {
  let isDown, pointer, rect;

  canvasFabric.defaultCursor = 'crosshair';

  canvasFabric.on('mouse:down', (o) => {
    isDown = true;

    pointer = canvasFabric.getPointer(o.e);

    rect = new fabric.Rect({
      left: pointer.x,
      top: pointer.y,
      originX: 'left',
      originY: 'top',
      cornerColor: 'white',
      transparentCorners: false,
      width: canvasFabric.getPointer(o.e).x - pointer.x,
      height: canvasFabric.getPointer(o.e).y - pointer.y,
      stroke: '#9BC225',
      fill: 'rgba(36, 49, 67, 0.7)',
      strokeWidth: 4
    });

    rect.controls = {
      ...fabric.Rect.prototype.controls,
      mtr: new fabric.Control({ visible: false })
    };

    canvasFabric.add(rect);
    canvasFabric.setActiveObject(rect);

    window.dispatchEvent(new Event('boxAdded'))
  });

  canvasFabric.on('mouse:move', (o) => {
    if (!isDown) return;

    if (pointer.x > canvasFabric.getPointer(o.e).x) rect.set({ left: Math.abs(canvasFabric.getPointer(o.e).x) });
    if (pointer.y > canvasFabric.getPointer(o.e).y) rect.set({ top: Math.abs(canvasFabric.getPointer(o.e).y) });

    rect.set({ width: Math.abs(pointer.x - canvasFabric.getPointer(o.e).x) });
    rect.set({ height: Math.abs(pointer.y - canvasFabric.getPointer(o.e).y) });

    canvasFabric.renderAll();
  });

  canvasFabric.on('mouse:up', () => {
    isDown = false;
    releaseMouseEventListeners(canvasFabric);
  });
};

export const addNewObjectWithCoordinates = (canvasFabric, coordinates = { left: 20, top: 20}, width = 200, height = 300) => {
  const rect = new fabric.Rect({
    left: coordinates.left,
    top: coordinates.top,
    width,
    height,
    cornerColor: 'white',
    transparentCorners: false,
    stroke: '#9BC225',
    fill: 'rgba(36, 49, 67, 0.7)',
    hasRotatingPoint: false,
    strokeWidth: 4
  });

  rect.controls = {
    ...fabric.Rect.prototype.controls,
    mtr: new fabric.Control({ visible: false })
  };

  canvasFabric.add(rect);
  canvasFabric.setActiveObject(rect);
};

export const removeActiveObject = (canvasFabric) => {
  if (!canvasFabric) return;

  try {
    const objectToRemove = canvasFabric.getActiveObject();

    canvasFabric.remove(objectToRemove);
    canvasFabric.dispose();

    return objectToRemove;
  } catch (e) {
    return false
  }
};

export const releaseMouseEventListeners = (canvasFabric) => {
  canvasFabric.defaultCursor = '';
  return canvasFabric.__eventListeners = {}
};
